/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function showAgeModal(time_now) {
  
  function getThree_hours_before_now(){
    
  	const result = new Date();
    result.setHours(result.getHours() - 3);
    return result;
  }
  
  if (window.theme.show_ageModal) {
    
	window.addEventListener('load', function () {

        document.querySelector('.btn_agree').onclick = function() {
           document.getElementById('modal-demo').style.display = 'none';
           document.getElementsByTagName('html')[0].classList.remove("scroll");
           localStorage.setItem('ageVerifiedDate', (new Date()).toISOString());
        };
      
		const age_verified_date = new Date(localStorage.getItem('ageVerifiedDate') || 0);
      	const three_hours_before_now = getThree_hours_before_now();
              
        if( three_hours_before_now > age_verified_date ) { 
              document.getElementById('modal-demo').style.display = 'flex';
              document.getElementsByTagName('html')[0].classList.add("scroll");
        } else {
              localStorage.setItem('ageVerifiedDate', (new Date().toISOString()));
        };
    })
  }
})();


document.addEventListener('DOMContentLoaded', function () {
    const shipsecCodeField = document.querySelector('[data-field-id="shipsec_code"]');

    if (shipsecCodeField) {
        shipsecCodeField.addEventListener('input', function () {
            const code = shipsecCodeField.value;

            if (code) {
                fetch('https://<your-app-url>/api/validate_code', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ code: code }),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.status === 'success') {
                            // Autofill address fields
                            document.querySelector('[name="checkout[shipping_address][address1]"]').value = data.address.address1;
                            document.querySelector('[name="checkout[shipping_address][address2]"]').value = data.address.address2;
                            document.querySelector('[name="checkout[shipping_address][city]"]').value = data.address.city;
                            document.querySelector('[name="checkout[shipping_address][province]"]').value = data.address.province;
                            document.querySelector('[name="checkout[shipping_address][country]"]').value = data.address.country;
                            document.querySelector('[name="checkout[shipping_address][zip]"]').value = data.address.zip;
                        } else {
                            alert('Invalid ShipSec Code.');
                        }
                    })
                    .catch((error) => {
                        console.error('Error validating code:', error);
                    });
            }
        });
    }
});






// console.log("Custom js")
// if(document.querySelector(".visually-hidden").textContent === "Payment"){
//   console.log(true);
// }